import { lazyPage } from './lazyPage';
import type { AppRoute } from './types';

const ModuleMenu = lazyPage(() => import('@/pages/ModuleMenu'));
const TransportDashboard = lazyPage(() => import('@/pages/transport/Dashboard'));
const TransportRoutesPage = lazyPage(() => import('@/pages/transport/RoutesPage'));
const Stops = lazyPage(() => import('@/pages/transport/Stops'));
const Vehicles = lazyPage(() => import('@/pages/transport/Vehicles'));
const Drivers = lazyPage(() => import('@/pages/transport/Drivers'));
const StudentAllocation = lazyPage(() => import('@/pages/transport/StudentAllocation'));
const TransportAttendance = lazyPage(() => import('@/pages/transport/TransportAttendance'));
const PickupDropTracking = lazyPage(() => import('@/pages/transport/PickupDropTracking'));
const TransportFees = lazyPage(() => import('@/pages/transport/TransportFees'));
const VehicleMaintenance = lazyPage(() => import('@/pages/transport/VehicleMaintenance'));
const RouteOptimization = lazyPage(() => import('@/pages/transport/RouteOptimization'));
const TransportAlerts = lazyPage(() => import('@/pages/transport/Alerts'));
const TransportReports = lazyPage(() => import('@/pages/transport/Reports'));
const TransportExpenses = lazyPage(() => import('@/pages/transport/Expenses'));

export const transportRoutes: AppRoute[] = [
  {
    path: 'transport',
    title: 'Transportation',
    children: [
      { path: '', title: 'Transportation', component: ModuleMenu },
      { path: 'dashboard', title: 'Dashboard', component: TransportDashboard },
      { path: 'routes', title: 'Routes', component: TransportRoutesPage },
      { path: 'stops', title: 'Stops', component: Stops },
      { path: 'vehicles', title: 'Vehicles', component: Vehicles },
      { path: 'drivers', title: 'Drivers', component: Drivers },
      { path: 'allocation', title: 'Student Allocation', component: StudentAllocation },
      { path: 'attendance', title: 'Transport Attendance', component: TransportAttendance },
      { path: 'tracking', title: 'Pickup & Drop Tracking', component: PickupDropTracking },
      { path: 'fees', title: 'Transport Fees', component: TransportFees },
      { path: 'maintenance', title: 'Vehicle Maintenance', component: VehicleMaintenance },
      { path: 'optimization', title: 'Route Optimization', component: RouteOptimization },
      { path: 'alerts', title: 'Alerts', component: TransportAlerts },
      { path: 'reports', title: 'Transport Reports', component: TransportReports },
      { path: 'expenses', title: 'Expenses', component: TransportExpenses },
    ],
  },
];
